const bootstrap  = require('bootstrap')
window.bootstrap = bootstrap;
